const escapeValue = value => encodeURI(JSON.stringify(value));

const unescapeValue = escapedValue => JSON.parse(decodeURI(escapedValue));
/**
 *
 * Encodes data to URISearchParams
 * @param paramsObject - paramName->paramValue {number|boolean|object} !Note that strings as param-value are not supported,
 * but objects with string valued fields or string valued arrays can be encoded and decoded.
 * @returns {string}
 */

export const toSearchParam = paramsObject => {
    const params = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    Object.entries(paramsObject).forEach(([param, value]) => {
        params.append(param, escapeValue(value));
    });

    return `?${params}`;
};
/**
 * Decodes back the result of toSearchParam
 * @param search {string} - search params from location
 * @returns paramsObject {object}
 */

export const fromSearchParam = search => {
    const params = new URLSearchParams(search);
    const paramsObject = {};
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    Array.from(params.entries()).forEach(([param, escapedValue]) => {
        paramsObject[param] = unescapeValue(escapedValue);
    });

    return paramsObject;
};

export const utoa = str => {
    try {
        return window.btoa(encodeURIComponent(str));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);

        return [];
    }
};

export const atou = str => {
    try {
        return decodeURIComponent(window.atob(str));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);

        return [];
    }
};

const identityMapping = e => e;

export const encodeSearchUrl = (paramsObject, transform = identityMapping) => {
    const params = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    Object.entries(paramsObject).forEach(([param, value]) => {
        params.append(param, transform(value));
    });

    return params;
};

export const decodeSearchUrl = (transform = identityMapping) => {
    const params = new URLSearchParams(window.location.search);
    const paramsObject = {};
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    Array.from(params.entries()).forEach(([param, value]) => {
        paramsObject[param] = transform(value);
    });

    return paramsObject;
};

export const shareLinkForItem = (basePath, params) => {
    const search = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            continue;
        }

        search.set(key, value);
    }

    const queryString = search.toString();

    return queryString ? `${basePath}?${queryString}` : basePath;
};

/** Builds `basePath?param=a&param=b` for repeated query keys. Returns null when no values. */
export const buildPathWithRepeatedParam = (basePath, paramName, values) => {
    const list = [].concat(values).filter(v => v != null && String(v).trim() !== '');
    if (!list.length) return null;

    const search = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    list.forEach(value => search.append(paramName, value));
    const separator = basePath.includes('?') ? '&' : '?';

    return `${basePath}${separator}${search}`;
};
